import React, { useState } from 'react';
import { Card } from '../ui/Card';
import { motion } from 'framer-motion';
import { RefreshCw, Heart, Handshake } from 'lucide-react';
const cardData = [{
  icon: RefreshCw,
  title: 'Renew',
  desc: 'Keep the vibe going for another 7 days.',
  color: 'text-blue-600',
  bg: 'bg-blue-50',
  backMessage: '"Let\'s keep this going! Another week sounds perfect. Same time tomorrow? 😊"'
}, {
  icon: Heart,
  title: 'Graduate',
  desc: 'Ready for real? Move to official status.',
  color: 'text-pink-600',
  bg: 'bg-pink-50',
  backMessage: '"This week was amazing. I think we\'re ready for something more. Want to make it official? 💘"'
}, {
  icon: Handshake,
  title: 'Friendly Landing',
  desc: 'End it kindly. No ghosting required.',
  color: 'text-gray-600',
  bg: 'bg-gray-100',
  backMessage: '"I had a great time getting to know you. I think we\'re better as friends, but I\'m glad we did this. Take care! 🤝"'
}];
export function DaySeven() {
  const [flippedCards, setFlippedCards] = useState<number[]>([]);
  const toggleFlip = (index: number) => {
    if (flippedCards.includes(index)) {
      setFlippedCards(flippedCards.filter(i => i !== index));
    } else {
      setFlippedCards([...flippedCards, index]);
    }
  };
  return <section className="py-20 bg-white" data-id="element-23">
      <div className="container mx-auto px-4" data-id="element-24">
        <div className="text-center mb-16" data-id="element-25">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-26">
            Day 7: The Moment
          </h2>
          <p className="text-xl text-muted-foreground" data-id="element-27">
            No endless limbo. No dramatic DTR. Just a clean choice.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-28">
          {cardData.map((item, i) => <div key={i} className="w-full" style={{
          perspective: '1000px'
        }} data-id="element-29">
              <motion.div className="relative w-full cursor-pointer" style={{
            transformStyle: 'preserve-3d',
            minHeight: '320px'
          }} animate={{
            rotateY: flippedCards.includes(i) ? 180 : 0
          }} transition={{
            duration: 0.6
          }} onClick={() => toggleFlip(i)} data-id="element-30">
                {/* Front Side */}
                <div className="absolute inset-0 w-full" style={{
              backfaceVisibility: 'hidden'
            }} data-id="element-31">
                  <Card className="p-8 h-full flex flex-col items-center text-center border-2 hover:border-gray-200 transition-colors" data-id="element-32">
                    <div className={`w-16 h-16 rounded-full ${item.bg} ${item.color} flex items-center justify-center mb-6`} data-id="element-33">
                      <item.icon className="w-8 h-8" data-id="element-34" />
                    </div>
                    <h3 className="text-2xl font-bold mb-3" data-id="element-35">{item.title}</h3>
                    <p className="text-muted-foreground mb-auto" data-id="element-36">{item.desc}</p>
                    <p className="text-xs text-gray-400 mt-6" data-id="element-37">
                      Tap to see message
                    </p>
                  </Card>
                </div>

                {/* Back Side */}
                <div className="absolute inset-0 w-full" style={{
              backfaceVisibility: 'hidden',
              transform: 'rotateY(180deg)'
            }} data-id="element-38">
                  <Card className="p-8 h-full flex flex-col items-center justify-center text-center border-2" style={{
                borderColor: '#ff6b6b'
              }} data-id="element-39">
                    <div className="mb-4 text-4xl" data-id="element-40">
                      {item.title === 'Renew' ? '🔁' : item.title === 'Graduate' ? '💘' : '🤝'}
                    </div>
                    <p className="text-lg italic leading-relaxed text-gray-700 mb-auto" data-id="element-41">
                      {item.backMessage}
                    </p>
                    <p className="text-xs text-gray-400 mt-6" data-id="element-42">
                      Tap to flip back
                    </p>
                  </Card>
                </div>
              </motion.div>
            </div>)}
        </div>
      </div>
    </section>;
}